// possible options:
// microsoft
// google
// saml
// password

import { getAuthMethods } from 'services/config/runtimeConfig';

// The enabled auth methods come from the runtime tenant config rather than `import.meta.env`,
// so a single native binary reflects the selected instance.
// These are functions because on native the config is not known until a workspace is selected, *after* these modules load.
// On web the config is seeded synchronously from the build-time env, so the result is unchanged.
const getEnabledAuthMethods = () =>
  (getAuthMethods() || 'microsoft,google,password').split(',').map((method) => method.trim().toLowerCase());

const isMicrosoftEnabled = () => getEnabledAuthMethods().includes('microsoft');
const isGoogleEnabled = () => getEnabledAuthMethods().includes('google');
const isSamlEnabled = () => getEnabledAuthMethods().includes('saml');
const isPasswordEnabled = () => getEnabledAuthMethods().includes('password');

export { isMicrosoftEnabled, isGoogleEnabled, isSamlEnabled, isPasswordEnabled };
